import React from 'react';
import { useStyles } from '../styles';
import { NavLink } from 'react-router-dom';

type PNavHeaderLink = {
  img?: any;
  alt?: string;
  to: string;
  title: string;
};

export const NavHeaderLink: React.FC<PNavHeaderLink> = (props) => {
  const classes = useStyles();
  const { img, alt, to, title } = props;
  return (
    <NavLink
      to={to}
      className={classes.menu__link}
      activeClassName={classes.menu__link_active}>
      {img && <img src={img} alt={alt} className={classes.menuIco} />}
      <span>{title}</span>
    </NavLink>
  );
};
